<template>
    <div id="manageSubcate">
        <div class="row mb-2">
            <div class="col-12">
                ประเภทค่าใช้จ่าย
                 <multiselect v-model="cate_exp" :options="cate_exp_list"  placeholder="เลือกประเภทค่าใช้จ่าย.."
                           label="cate_exp_name" track-by="cate_exp_name" @select="getSubcate"></multiselect>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col">
                รายการค่าใช้จ่าย
                <input type="text" class="form-control" v-model="sub_cate" placeholder="รายการค่าใช้จ่ายใหม่...">
            </div>
            <div class="col-3 pt-4">
                <button class="btn btn-success btn-block" @click="newSub">เพิ่ม</button>
            </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead>
                <tr class="text-center">
                  <th scope="col">#</th>
                  <th scope="col">รายการ</th>
                  <th scope="col">ลบ</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(s, i) in sub_cate_exp_list" :key="'s' + i">
                  <th scope="row">{{ i + 1 }}</th>
                  <td>
                    <input type="text" :class="{ 'hidden-border': edit_status == 0, 'form-control': edit_status == 1 } "
                     v-model="s.sub_cate_expense_name" :readonly="edit_status == 0">
                  </td>
                  <td class="text-center">
                    <button class="btn btn-danger btn-sm" 
                    v-if="edit_status == 0"
                    @click="remove(s.sub_cate_expense_id)">
                      <i class="fas fa-trash-alt"></i>
                    </button>
                     <button class="btn btn-warning btn-sm"
                      v-if="edit_status == 0"
                     @click="edit()">
                      <i class="fas fa-pen-square"></i>
                    </button>
                    <button class="btn btn-success btn-sm"
                      v-if="edit_status == 1"
                     @click="update(s.sub_cate_expense_id, s.sub_cate_expense_name)">
                      <i class="fas fa-save"></i>
                    </button>
                    <button class="btn btn-danger btn-sm"
                      v-if="edit_status == 1"
                     @click="edit_status = 0">
                      <i class="fas fa-times"></i>
                    </button>
                  </td>
                </tr>
                <tr v-if="sub_cate_exp_list.length < 1">
                  <th scope="row" colspan="3" class="text-center">ไม่มีข้อมูล</th>
                </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>

<style>
  .hidden-border {
    border: 0px!important;
    background: #fff!important;
  }
</style>

<script>
import api from '../services/service_expend'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect
  },
  data () {
    return {
      cate_exp_list: [],
      cate_exp: 0,
      sub_cate_exp_list: [],
      sub_cate: '',
      header: {
        headers: {
          'Access-Token': this.$store.state.token
        }
      },
      edit_status: 0
    }
  },
  methods: {
    getCate () {
      this.$store.state.isLoading = true
      var body = {
        search: '',
        active_page: 1,
        per_page: 10000000000000
      }
      api.getCate(
        body,
        this.header,
        result => {
          if (result.response === true) {
            this.cate_exp_list = result.data
            this.cate_exp = this.cate_exp_list[0]
            this.getSubcate(this.cate_exp)
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getSubcate (value) {
      this.$store.state.isLoading = true
      setTimeout(() => {
        api.getSub(
          value.cate_exp_id,
          this.header,
          result => {
            if (result.response === true) {
              if (result.data.sub_menu) {
                this.sub_cate_exp_list = result.data.sub_menu
                this.edit_status = 0
              } else {
                this.sub_cate_exp_list = []
              }
            } else {
              Swal.fire('ดึงข้อมูลค่าใช้จ่าย', result.message, 'warning')
            }
            this.$store.state.isLoading = false
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        )
      }, 200)
    },
    newSub () {
      if (this.sub_cate !== '') {
        const obj = {
          sub_cate_expense_name: this.sub_cate,
          sub_cate_expense_description: '',
          cate_exp_id: this.cate_exp.cate_exp_id
        }

        api.addSubExpen(
          obj,
          this.header,
          result => {
            if (result.response === true) {
              this.alert_msg('success', 'เพิ่มรายการค่าใข้จ่าย', result.data)
              this.getSubcate(this.cate_exp)
              this.sub_cate = ''
            } else {
              Swal.fire('ดึงข้อมูลค่าใช้จ่าย', result.message, 'warning')
            }
            this.$store.state.isLoading = false
          },
          error => {
            alert(JSON.stringify(error))
            this.$store.state.isLoading = false
          }
        )
      }
    },
    remove (id) {
      api.delSubExpen(
        id,
        this.header,
        result => {
          if (result.response === true) {
            this.alert_msg('success', 'ลบรายการค่าใข้จ่าย', result.data)
            this.getSubcate(this.cate_exp)
            this.sub_cate = ''
          } else {
            Swal.fire('ดึงข้อมูลค่าใช้จ่าย', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    edit () {
      this.edit_status = 1
    },
    update (id, text) {
      const obj = {
        sub_cate_expense_id: parseInt(id),
        sub_cate_expense_name: text,
        sub_cate_expense_description: '',
        cate_exp_id: parseInt(this.cate_exp.cate_exp_id)
      }
      api.updateSubExpen(
        obj,
        this.header,
        result => {
          if (result.response === true) {
            this.edit_status = 0
            this.alert_msg('success', 'แก้ไขรายการค่าใข้จ่าย', result.data)
            this.getSubcate(this.cate_exp)
            this.sub_cate = ''
          } else {
            Swal.fire('ดึงข้อมูลค่าใช้จ่าย', result.message, 'warning')
          }
          this.$store.state.isLoading = false
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.getCate()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/subcate_view.vue